/* ==========================================================================
   assets/lookbook.js
   --------------------------------------------------------------------------
   Load:  <script src="{{ 'lookbook.js' | asset_url }}" defer="defer"></script>
          (ye line snippets/look-book-final.liquid ke andar pehle se hai)

   Zaroori: .js asset file ke andar Liquid ({{ section.id }}, {{ tab2_count }})
   kaam NAHI karta. Isliye ye file IDs ki jagah data-attributes padhti hai:

     data-lb-modal          -> .product-look-book-mdl (modal wrapper)
     data-lb-base-count     -> metafield images ka count (Liquid se)
     data-lb-count          -> "Customer Images" tab ka count <span>
     data-lb-grid           -> customer images grid
     data-lb-jdgm-html      -> <template> Judge.me widget HTML
     data-lb-jdgm-json      -> <script type="application/json"> Judge.me data
     data-lb-root / data-lb-sheet / data-lb-size / data-lb-submit ... -> quick add

   Sections:
     1) Quick add bottom sheet
     2) [COMMENTED] Purana customer images slider (slick) — reference ke liye
     3) Customer images grid (rating + naam)
     4) Fullscreen photo viewer
   ========================================================================== */


/* ==========================================================================
   1) QUICK ADD BOTTOM SHEET
   ========================================================================== */
(function () {
    'use strict';

    if (window.__lbQuickAddInit) return;
    window.__lbQuickAddInit = true;

    var MODAL = '.product-look-book-mdl';

    function rootOf(el) { return el.closest('[data-lb-root]'); }
    function sheetOf(root) { return root.querySelector('[data-lb-sheet]'); }

    function setError(root, msg) {
        var el = root.querySelector('[data-lb-error]');
        if (!el) return;
        el.textContent = msg || '';
        el.hidden = !msg;
    }

    function selectSize(root, btn) {
        var sheet = sheetOf(root);
        root.querySelectorAll('[data-lb-size]').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        sheet.dataset.variantId = btn.dataset.variantId;

        var price = root.querySelector('[data-lb-price]');
        if (price && btn.dataset.price) price.innerHTML = btn.dataset.price;

        var submit = root.querySelector('[data-lb-submit]');
        if (submit) {
            submit.classList.add('is-ready');
            var label = submit.querySelector('[data-lb-submit-label]');
            if (label) label.textContent = 'Add to Bag';
        }
        setError(root, '');
    }

    function addToBag(root, btn) {
        var sheet = sheetOf(root);
        var id = sheet.dataset.variantId;

        if (!id) {
            var sizes = root.querySelector('[data-lb-sizes]');
            if (sizes) {
                sizes.classList.remove('lb-shake');
                void sizes.offsetWidth; // animation restart
                sizes.classList.add('lb-shake');
            }
            setError(root, 'Select a size to add this to your bag.');
            return;
        }

        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { id: Number(id), quantity: 1 };
        if (cart && typeof cart.getSectionsToRender === 'function') {
            body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
        }

        btn.classList.add('is-loading');
        setError(root, '');

        var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
        })
            .then(function (res) {
                return res.json().then(function (data) { return { ok: res.ok, data: data }; });
            })
            .then(function (result) {
                if (!result.ok) {
                    setError(root, result.data.description || result.data.message || 'This item could not be added. Try again.');
                    return;
                }
                var data = result.data;

                root.classList.remove('lb-sheet-open');
                var closeBtn = root.querySelector('.tab-product-single-close-wrapp');
                if (closeBtn) closeBtn.click();

                if (cart && typeof cart.renderContents === 'function') {
                    cart.classList.remove('is-empty');
                    cart.renderContents(data);
                }
                if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
                    window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lookbook-quick-add', productVariantId: id, cartData: data });
                }
                document.dispatchEvent(new CustomEvent('lookbook:added-to-cart', { detail: data }));
            })
            .catch(function () {
                setError(root, 'Connection problem. Check your internet and try again.');
            })
            .then(function () {
                // .finally() ki jagah .then() — purane Safari/iOS par bhi chalega
                btn.classList.remove('is-loading');
            });
    }

    // capture: true -> modal ka koi script click rok de, tab bhi ye pehle chalega.
    // Sirf lookbook modal ke andar ke clicks par kaam karta hai (baaki site safe).
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest || !t.closest(MODAL)) return;
        var el;

        if ((el = t.closest('[data-lb-open]'))) {
            e.preventDefault();
            e.stopPropagation();
            rootOf(el).classList.add('lb-sheet-open');
            return;
        }
        if ((el = t.closest('[data-lb-close]'))) {
            e.preventDefault();
            e.stopPropagation();
            rootOf(el).classList.remove('lb-sheet-open');
            return;
        }
        if ((el = t.closest('.tab-product-single-close-wrapp'))) {
            var r = rootOf(el);
            if (r) r.classList.remove('lb-sheet-open');
            return; // modal ka apna close handler bhi chalne do
        }
        if ((el = t.closest('[data-lb-size]'))) {
            e.preventDefault();
            e.stopPropagation();
            if (!el.disabled) selectSize(rootOf(el), el);
            return;
        }
        if ((el = t.closest('[data-lb-submit]'))) {
            e.preventDefault();
            e.stopPropagation();
            addToBag(rootOf(el), el);
        }
    }, true);

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var viewerOpen = document.querySelector('.lb-viewer:not([hidden])');
        if (viewerOpen) return; // pehle viewer band hoga (section 4)
        var open = document.querySelector(MODAL + ' [data-lb-root].lb-sheet-open');
        if (open) open.classList.remove('lb-sheet-open');
    });
})();


/* ==========================================================================
   2) [COMMENTED] PURANA CUSTOMER IMAGES SLIDER (slick)
   --------------------------------------------------------------------------
   Ye ab use nahi ho raha (grid ne replace kar diya). Reference ke liye rakha hai.
   Isko theek kar diya hai taaki zaroorat pade to seedha uncomment karke chal jaaye:
     - Liquid hata diya ({{ section.id }}, {{ tab2_count }}) -> data-attributes
     - Har modal ke liye alag chalta hai (ek page par 2 sections ho to bhi)
     - Template wali images ka bhi extension check hota hai (pehle nahi tha)
     - Slides DOM API se bante hain (string concat se HTML injection ka risk khatam)
     - Kaam ke baad bhaari template/JSON DOM se hata diya jata hai

   Uncomment karne par snippet mein ye markup chahiye:
     <div class="slider-wrapper-looksbook h-100 modal-wrapper-lookbook1" data-lb-slider>...</div>
     <template data-lb-jdgm-html>{{ jdgm_widget }}</template>
     <script type="application/json" data-lb-jdgm-json>{{ jdgm_json }}</script>
     <span data-lb-count>{{ tab2_count }}</span>
     modal wrapper par: data-lb-base-count="{{ tab2_count }}"
   ========================================================================== */
/*
(function () {
    'use strict';

    if (window.__lbSliderInit) return;
    window.__lbSliderInit = true;

    function cleanUrl(src) {
        if (!src || typeof src !== 'string') return null;
        src = src.trim();
        if (!src || src === '#' || src.indexOf('javascript') === 0) return null;
        if (src.indexOf('//') === 0) src = 'https:' + src;
        if (/\.(mp4|mov|webm)(\?|$)/i.test(src)) return null;   // video skip
        if (!/\.(jpe?g|png|webp|gif)(\?|$)/i.test(src)) return null;
        return src;
    }

    function buildSlider(modal) {
        var slider = modal.querySelector('[data-lb-slider]');
        var countEl = modal.querySelector('[data-lb-count]');
        if (!slider) return;

        var seen = {};
        var urls = [];

        function addUrl(src) {
            src = cleanUrl(src);
            if (!src || seen[src]) return;
            seen[src] = true;
            urls.push(src);
        }

        // 1) Old HTML widget se images (full size photo prefer karo)
        var tpl = modal.querySelector('template[data-lb-jdgm-html]');
        if (tpl) {
            tpl.content.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__pics img').forEach(function (img) {
                var link = img.closest('a');
                addUrl(
                    (link && (link.getAttribute('data-mfp-src') || link.getAttribute('href'))) ||
                    img.getAttribute('data-src') ||
                    img.getAttribute('src')
                );
            });
        }

        // 2) New JSON data se images
        var jsonEl = modal.querySelector('script[data-lb-jdgm-json]');
        if (jsonEl) {
            var data = null;
            try { data = JSON.parse(jsonEl.textContent); } catch (e) { console.warn('Judge.me JSON parse error', e); }

            var walk = function (node, insideMedia) {
                if (!node) return;
                if (typeof node === 'string') { if (insideMedia) addUrl(node); return; }
                if (Array.isArray(node)) { node.forEach(function (n) { walk(n, insideMedia); }); return; }
                if (typeof node === 'object') {
                    Object.keys(node).forEach(function (key) {
                        if (/avatar|product_image|product_img|logo/i.test(key)) return;
                        walk(node[key], insideMedia || /pic|photo|media|image/i.test(key));
                    });
                }
            };
            walk(data, false);
        }

        if (tpl) tpl.remove();
        if (jsonEl) jsonEl.remove();

        if (!urls.length) return;

        var $ = window.jQuery;
        var slickReady = !!($ && $(slider).hasClass('slick-initialized'));

        urls.forEach(function (src) {
            var slide = document.createElement('div');
            slide.className = 'add-to-cart-slide is-jdgm-review';

            var wrap = document.createElement('div');
            wrap.className = 'main-image-cart';

            var img = document.createElement('img');
            img.src = src;
            img.loading = 'lazy';
            img.decoding = 'async';
            img.className = 'lazy-image';
            img.alt = 'Customer review image';
            img.width = 800;

            wrap.appendChild(img);
            slide.appendChild(wrap);

            if (slickReady) { $(slider).slick('slickAdd', slide); }
            else { slider.appendChild(slide); }
        });

        if (countEl) {
            countEl.textContent = (parseInt(modal.dataset.lbBaseCount, 10) || 0) + urls.length;
        }
    }

    function run() {
        document.querySelectorAll('.product-look-book-mdl').forEach(buildSlider);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
})();
*/


/* ==========================================================================
   3) CUSTOMER IMAGES GRID (★ rating · naam)
   --------------------------------------------------------------------------
   Page load ke baad browser ke idle time mein chalta hai (load slow nahi hota).
   Agar user usse pehle lookbook khole, to usi waqt ban jata hai.
   ========================================================================== */
(function () {
    'use strict';

    if (window.__lbGridInit) return;
    window.__lbGridInit = true;

    var MODAL = '.product-look-book-mdl';

    function cleanUrl(src) {
        if (!src || typeof src !== 'string') return null;
        src = src.trim();
        if (!src || src === '#' || src.indexOf('javascript') === 0) return null;
        if (src.indexOf('//') === 0) src = 'https:' + src;
        if (/\.(mp4|mov|webm)(\?|$)/i.test(src)) return null;   // video skip
        if (!/\.(jpe?g|png|webp|gif)(\?|$)/i.test(src)) return null;
        return src;
    }

    // "Ananya Rao" -> "Ananya R."
    function shortName(n) {
        if (!n) return '';
        var parts = String(n).trim().replace(/\s+/g, ' ').split(' ');
        if (parts.length < 2) return parts[0];
        var last = parts[parts.length - 1];
        return parts[0] + ' ' + last.charAt(0).toUpperCase() + '.';
    }

    function formatRating(r) {
        var num = Number(r);
        if (!num) return '';
        return num % 1 === 0 ? String(num) : num.toFixed(1);
    }


    // searchParams.set() purane width/w ko REPLACE karta hai, duplicate nahi banata.
    function resized(src, w, square) {
        if (!src) return src;
        try {
            var url = new URL(src, window.location.href);

            // Judge.me ka apna server: sirf width + quality support hai
            if (url.hostname.indexOf('judgeme.com') !== -1) {
                url.searchParams.set('width', w);
                url.searchParams.set('quality', '80');
                return url.toString();
            }

            // imgix server
            if (url.hostname.indexOf('imgix.net') !== -1) {
                url.searchParams.set('w', w);
                url.searchParams.set('auto', 'format');
                if (square) {
                    url.searchParams.set('h', w);
                    url.searchParams.set('fit', 'crop');
                } else {
                    url.searchParams.delete('h');
                }
                return url.toString();
            }
        } catch (e) { /* galat URL -> original hi use karo */ }
        return src;
    }

    function createCard(item) {
        var name = shortName(item.name);
        var rating = formatRating(item.rating);

        var card = document.createElement('div');
        card.className = 'lb-cgrid__item';
        card.dataset.full = item.src;
        card.tabIndex = 0;
        card.setAttribute('role', 'button');
        card.setAttribute('aria-label', name ? 'Open photo by ' + name : 'Open photo');

        var img = document.createElement('img');
        // img.src = item.src;
        img.src = resized(item.src, 500, false);
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = name ? 'Photo by ' + name : 'Customer photo';
        img.width = 500;
        img.height = 625;
        card.appendChild(img);

        if (rating || name) {
            // DOM API se banao (innerHTML nahi), taaki customer ke naam se HTML inject na ho
            var badge = document.createElement('span');
            badge.className = 'lb-cgrid__badge';
            if (rating) {
                var star = document.createElement('span');
                star.className = 'lb-star';
                star.setAttribute('aria-hidden', 'true');
                star.textContent = '\u2605';
                badge.appendChild(star);
            }
            badge.appendChild(document.createTextNode([rating, name].filter(Boolean).join(' \u00B7 ')));
            card.appendChild(badge);
        }
        return card;
    }
        // Customer Images mein ek bhi photo nahi -> tab chhupa do, aur Lookbook tab khol do
    function hideEmptyCustomerTab(modal) {
        if ((parseInt(modal.dataset.lbBaseCount, 10) || 0) > 0) return; // metafield photos hain

        var link = modal.querySelector('.look-book-link-add[data-tab="tab_2"]');
        var panel = modal.querySelector('[data-content="tab_2"]');
        var wasActive = !!(link && link.classList.contains('active'));

        if (link) link.style.display = 'none';
        if (panel) panel.style.display = 'none';

        if (wasActive) {
            var tab1 = modal.querySelector('.look-book-link-add[data-tab="tab_1"]');
            if (tab1) tab1.click();
        }
    }


    function buildGrid(modal) {
        if (modal.dataset.lbGridReady) return; // ek hi baar
        modal.dataset.lbGridReady = '1';

        var grid = modal.querySelector('[data-lb-grid]');
        var countEl = modal.querySelector('[data-lb-count]');
        var tpl = modal.querySelector('template[data-lb-jdgm-html]');
        var jsonEl = modal.querySelector('script[data-lb-jdgm-json]');
                if (!grid || (!tpl && !jsonEl)) { hideEmptyCustomerTab(modal); return; }

        var seen = {};
        var items = [];

        function addItem(src, rating, name) {
            src = cleanUrl(src);
            if (!src || seen[src]) return;
            seen[src] = true;
            items.push({ src: src, rating: rating, name: name });
        }

        // 1) Old HTML widget: har review ke andar se rating + naam + photos
        if (tpl) {
            var root = tpl.content;
            root.querySelectorAll('.jdgm-rev').forEach(function (rev) {
                var ratingEl = rev.querySelector('.jdgm-rev__rating');
                var authorEl = rev.querySelector('.jdgm-rev__author');
                var rating = ratingEl ? ratingEl.getAttribute('data-score') : null;
                var name = authorEl ? authorEl.textContent : '';

                rev.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__pics img').forEach(function (img) {
                    var link = img.closest('a');
                    addItem(
                        (link && (link.getAttribute('data-mfp-src') || link.getAttribute('href'))) ||
                        img.getAttribute('data-src') ||
                        img.getAttribute('src'),
                        rating,
                        name
                    );
                });
            });

            // Review ke bahar koi photo ho to bhi le lo (bina rating/naam ke)
            root.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__pics img').forEach(function (img) {
                if (img.closest('.jdgm-rev')) return;
                addItem(img.getAttribute('data-src') || img.getAttribute('src'), null, '');
            });
        }

        // 2) New JSON data: jis object mein rating + naam ho, wahi review ka context
        if (jsonEl) {
            var data = null;
            try { data = JSON.parse(jsonEl.textContent); } catch (e) { console.warn('Judge.me JSON parse error', e); }

            var reviewContext = function (obj, ctx) {
                var r = obj.rating != null ? obj.rating : obj.score;
                var n = obj.reviewer_name || obj.author || obj.reviewer_display_name ||
                        (obj.reviewer && (obj.reviewer.name || obj.reviewer.display_name));
                if (r != null && !isNaN(Number(r)) && n) return { rating: r, name: n };
                return ctx;
            };

            var walk = function (node, insideMedia, ctx) {
                if (!node) return;
                if (typeof node === 'string') {
                    if (insideMedia) addItem(node, ctx && ctx.rating, ctx && ctx.name);
                    return;
                }
                if (Array.isArray(node)) {
                    for (var i = 0; i < node.length; i++) walk(node[i], insideMedia, ctx);
                    return;
                }
                if (typeof node === 'object') {
                    var nextCtx = reviewContext(node, ctx);
                    Object.keys(node).forEach(function (key) {
                        if (/avatar|product_image|product_img|logo/i.test(key)) return;
                        walk(node[key], insideMedia || /pic|photo|media|image/i.test(key), nextCtx);
                    });
                }
            };
            walk(data, false, null);
        }

        // Kaam ho gaya: bhaari HTML/JSON DOM se hata do (memory free)
        if (tpl) tpl.remove();
        if (jsonEl) jsonEl.remove();

        if (!items.length) { hideEmptyCustomerTab(modal); return; }

        var frag = document.createDocumentFragment();
        items.forEach(function (item) { frag.appendChild(createCard(item)); });
        grid.appendChild(frag);
        var pending = document.querySelector('[data-lb-thumb-pending]');
        if (pending) {
            var thumbImg = pending.querySelector('img');
            if (thumbImg) {
                thumbImg.onload = function () { pending.style.display = ''; };
                thumbImg.src = resized(items[0].src, 100, true);
            }
            pending.removeAttribute('data-lb-thumb-pending');
        }

        if (countEl) {
            countEl.textContent = (parseInt(modal.dataset.lbBaseCount, 10) || 0) + items.length;
        }
    }

    function buildAll() {
        document.querySelectorAll(MODAL).forEach(buildGrid);
    }

    function whenIdle(fn) {
        if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 4000 });
        else setTimeout(fn, 1500);
    }

    if (document.readyState === 'complete') whenIdle(buildAll);
    else window.addEventListener('load', function () { whenIdle(buildAll); }, { once: true });

    // Idle se pehle user ne lookbook khola -> turant bana do
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.lookBookClickAble, .look-book-link-add')) buildAll();
    }, true);
})();


/* ==========================================================================
   4) FULLSCREEN PHOTO VIEWER
   --------------------------------------------------------------------------
   Pehli baar photo click hone par hi banta hai. Band hone par slides hata di
   jaati hain taaki badi images memory mein na rahein.
   ========================================================================== */
(function () {
    'use strict';

    if (window.__lbViewerInit) return;
    window.__lbViewerInit = true;

    var MODAL = '.product-look-book-mdl';

    var viewer, track, countEl, prevBtn, nextBtn, closeBtn;
    var lastFocus = null;
    var currentIndex = 0;
    var rafId = 0;
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var ICON_CLOSE = '<svg viewBox="0 0 14 14" width="16" height="16" fill="none" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    var ICON_PREV  = '<svg viewBox="0 0 10 16" width="10" height="16" fill="none" aria-hidden="true"><path d="M8.5 1.5L2 8l6.5 6.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var ICON_NEXT  = '<svg viewBox="0 0 10 16" width="10" height="16" fill="none" aria-hidden="true"><path d="M1.5 1.5L8 8l-6.5 6.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function build() {
        viewer = document.createElement('div');
        viewer.className = 'lb-viewer';
        viewer.hidden = true;
        viewer.setAttribute('role', 'dialog');
        viewer.setAttribute('aria-modal', 'true');
        viewer.setAttribute('aria-label', 'Customer photos');
        viewer.innerHTML =
            '<div class="lb-viewer__top">' +
                '<span class="lb-viewer__count" aria-live="polite"></span>' +
                '<button type="button" class="lb-viewer__close" aria-label="Close">' + ICON_CLOSE + '</button>' +
            '</div>' +
            '<div class="lb-viewer__track"></div>' +
            '<button type="button" class="lb-viewer__nav lb-viewer__nav--prev" aria-label="Previous photo">' + ICON_PREV + '</button>' +
            '<button type="button" class="lb-viewer__nav lb-viewer__nav--next" aria-label="Next photo">' + ICON_NEXT + '</button>';
        document.body.appendChild(viewer);

        track    = viewer.querySelector('.lb-viewer__track');
        countEl  = viewer.querySelector('.lb-viewer__count');
        prevBtn  = viewer.querySelector('.lb-viewer__nav--prev');
        nextBtn  = viewer.querySelector('.lb-viewer__nav--next');
        closeBtn = viewer.querySelector('.lb-viewer__close');

        // Viewer ke andar ka click bahar na jaaye, warna lookbook modal ka
        // "outside click" logic modal band kar sakta hai
        viewer.addEventListener('click', function (e) {
            e.stopPropagation();
            if (e.target.closest('.lb-viewer__close')) { close(); return; }
            if (e.target.closest('.lb-viewer__nav--prev')) { go(-1); return; }
            if (e.target.closest('.lb-viewer__nav--next')) { go(1); }
        });

        track.addEventListener('scroll', function () {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(update);
        }, { passive: true });

        window.addEventListener('resize', function () {
            if (viewer.hidden) return;
            track.scrollLeft = currentIndex * track.clientWidth;
        }, { passive: true });
    }

    function update() {
        var width = Math.max(track.clientWidth, 1);
        var total = track.children.length;
        currentIndex = Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / width)));
        countEl.textContent = (currentIndex + 1) + ' / ' + total;
        prevBtn.disabled = currentIndex <= 0;
        nextBtn.disabled = currentIndex >= total - 1;
    }

    function go(dir) {
        track.scrollBy({ left: dir * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function open(grid, index) {
        if (!viewer) build();

        var frag = document.createDocumentFragment();
        grid.querySelectorAll('.lb-cgrid__item').forEach(function (card) {
            var thumb = card.querySelector('img');
            if (!thumb) return;

            var slide = document.createElement('figure');
            slide.className = 'lb-viewer__slide';

            var img = document.createElement('img');
            img.src = card.dataset.full || thumb.currentSrc || thumb.src;
            img.alt = thumb.alt || 'Customer photo';
            img.loading = 'lazy';
            img.decoding = 'async';
            slide.appendChild(img);

            var badge = card.querySelector('.lb-cgrid__badge');
            if (badge) {
                var copy = badge.cloneNode(true);
                copy.classList.add('lb-viewer__badge');
                slide.appendChild(copy);
            }
            frag.appendChild(slide);
        });

        track.textContent = '';
        track.appendChild(frag);

        lastFocus = document.activeElement;
        viewer.hidden = false;
        document.documentElement.classList.add('lb-viewer-lock');

        requestAnimationFrame(function () {
            track.scrollLeft = index * track.clientWidth;
            update();
            closeBtn.focus({ preventScroll: true });
        });
    }

    function close() {
        if (!viewer || viewer.hidden) return;
        viewer.hidden = true;
        document.documentElement.classList.remove('lb-viewer-lock');
        track.textContent = ''; // badi images memory se hata do
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }

    function openFromCard(card) {
        var grid = card.closest('.lb-cgrid');
        if (!grid) return;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.lb-cgrid__item'));
        open(grid, Math.max(0, cards.indexOf(card)));
    }

    // Grid photo click — capture: true, taaki modal ka script click rok na paaye.
    // Sirf lookbook modal ke andar ke cards par.
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var card = t.closest(MODAL + ' .lb-cgrid__item');
        if (!card) return;
        e.preventDefault();
        e.stopPropagation();
        openFromCard(card);
    }, true);

    // Keyboard: Enter/Space se photo khule, Esc se band, arrows se slide
    document.addEventListener('keydown', function (e) {
        if (viewer && !viewer.hidden) {
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
            else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
            return;
        }
        var t = e.target;
        var card = t && t.closest ? t.closest(MODAL + ' .lb-cgrid__item') : null;
        if (card && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            openFromCard(card);
        }
    }, true);
})();

/* ==========================================================================
   5) LOOKBOOK SLIDER SIZE FIX
   Modal khulne par aur har image load hone par slick ko dobara size naapne do
   ========================================================================== */
(function () {
    'use strict';

    if (window.__lbSliderSizeInit) return;
    window.__lbSliderSizeInit = true;

    var MODAL = '.product-look-book-mdl';
    var timer = 0;

    function refreshSliders() {
        var $ = window.jQuery;
        if (!$) return;
        $(MODAL + ' .slick-initialized').each(function () {
            $(this).slick('setPosition');
        });
    }

    // Kai images ek saath load hon to bhi ek hi baar refresh (debounce)
    function scheduleRefresh(delay) {
        clearTimeout(timer);
        timer = setTimeout(refreshSliders, delay || 60);
    }

    // Circle click -> modal khulta hai -> uske dikhne ke baad size naapo
    document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.lookBookClickAble, .look-book-link-add')) {
            scheduleRefresh(150);
        }
    }, true);

    // Modal ke andar koi bhi image load ho -> size dobara naapo
    // ('load' event bubble nahi hota, isliye capture: true)
    document.addEventListener('load', function (e) {
        var t = e.target;
        if (t && t.tagName === 'IMG' && t.closest && t.closest(MODAL + ' .modal-wrapper-lookbook')) {
            scheduleRefresh(60);
        }
    }, true);
})();